export default __webpack_public_path__ + "static/media/background-big.9cd12ec3.jpg";